import { useGetCustomerNameByPhoneNumberQuery } from "services/tickets";

export function useCustomerNameByPhoneNumber(phoneNumber: string) {
    const skip = !phoneNumber;
    const { data: customerNameByPhoneNumberRes, isLoading } = useGetCustomerNameByPhoneNumberQuery(phoneNumber!, {
        skip,
        refetchOnMountOrArgChange: true
    });

    return {
        customerNameByPhoneNumber: skip ? [] : customerNameByPhoneNumberRes?.data,
        isLoading
    };
}
